import React, { useState } from 'react';
import { Cell, Pie, PieChart, Sector } from 'recharts';
import { displayNumber } from '../../common/utils';

const COLORS = ['#1F8E87', '#1E4C49', '#B9DDCC', '#DBDFE2'];
const renderActiveShape = (props: any) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props;

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill="#000000" fontWeight={'bold'}>
        {displayNumber(payload.value)}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 3}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        cornerRadius={5}
      />
    </g>
  );
};

const renderInnerCircle = () => (
  <>
    <defs>
      <radialGradient id="grayGradient" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
        <stop offset="0" stopColor="#888888" stopOpacity="1" />
        <stop offset="70%" stopColor="#888888" stopOpacity="1" />
        <stop offset="100%" stopColor="#f0f0f0" stopOpacity="0.3" />
      </radialGradient>
    </defs>
    <circle cx="50%" cy="50%" r={68} stroke="url(#grayGradient)" strokeWidth="13" fill="none" />
  </>
);

interface MonthlyPaymentPieChartProps {
  monthlyPayment: number;
  principalAndInterest: number;
  propertyTaxes: number;
  homeownersInsurance: number;
  hoaFeesMonthly: number;
}
export const MonthlyPaymentPieChart: React.FC<MonthlyPaymentPieChartProps> = (props) => {
  const data = [
    { name: 'Principal & Interest', value: props.principalAndInterest },
    { name: 'Property Taxes', value: props.propertyTaxes },
    { name: 'Homeowners Insurance', value: props.homeownersInsurance },
    { name: 'Hoa fees monthly', value: props.hoaFeesMonthly }
  ];
  const [activeSector, setActiveSector] = useState(1);
  const onMouseEnterHandler = (_: any, index: number) => {
    setActiveSector(index);
  };
  const onMouseLeaveHandler = () => {
    setActiveSector(-1);
  };
  const renderLable = () => (
    <text x="50%" y="50%" dy={8} textAnchor="middle" fill="#000000" fontWeight={'bold'}>
      {displayNumber(props.monthlyPayment)}
    </text>
  );

  return (
    <PieChart width={250} height={250}>
      <Pie
        activeIndex={activeSector}
        activeShape={renderActiveShape}
        onMouseEnter={onMouseEnterHandler}
        onMouseLeave={onMouseLeaveHandler}
        label={activeSector === -1 ? renderLable : false}
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        innerRadius={80}
        outerRadius={120}
        cornerRadius={5}
        paddingAngle={1}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
            style={{ outline: 'none' }}
          />
        ))}
      </Pie>
      {renderInnerCircle()}
    </PieChart>
  );
};
